import React from 'react';
import { Input } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { BasicText } from '@components';
import './inputs.css';

const ShortInput = (props) => {
  const [passwordVisible, setPasswordVisible] = React.useState(false);

  const renderInput = () => {
    if (props.isPassword) {
      return (
        <Input.Password
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
          style={{ fontSize: '16px' }}
          visibilityToggle={{
            visible: passwordVisible,
            onVisibleChange: setPasswordVisible,
          }}
        />
      );
    } else {
      return (
        <Input
          placeholder={props.placeholder}
          type={props.type ? props.type : 'text'}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
          style={{ fontSize: '16px' }}
        />
      );
    }
  };

  return (
    <div
      className="short-input-container"
      style={{ maxWidth: props.maxWidth ? props.maxWidth : '100%' }}
    >
      {props.inputHeader && (
        <BasicText fontSize="12px">{props.inputHeader}</BasicText>
      )}
      {renderInput()}
    </div>
  );
};

export default ShortInput;
